import { z } from 'zod';
import { DocId, IsoTimestamp } from '../common.js';
/**
 * Training-video series — groups Videos into ordered playlists for the
 * library page (Production Engineering Foundations, Joining OneNebula,
 * Security Awareness 2026, etc.).
 *
 * Firestore path: `video_series/{seriesId}` (top-level, single shared
 * corpus). kb_admin writes; any authenticated user reads. Documented
 * exception under Hard Rule #1 in CLAUDE.md.
 *
 * A Video joins a series by setting `Video.seriesId`. Episode ordering
 * is driven off `Video.episode`. Soft-delete sets `deletedAt`; any
 * Videos still pointing at the series have their `seriesId` cleared in
 * the same batch (see backend/src/routes/video-series.ts).
 */
export const VideoSeries = z.object({
    id: DocId,
    title: z.string().min(1).max(200),
    subtitle: z.string().max(300).optional(),
    /** Links the series to a specialisation (drives the colour swatch). */
    specId: z.string().max(40).optional(),
    createdBy: DocId,
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
    deletedAt: IsoTimestamp.optional(),
});
export const CreateVideoSeriesBody = VideoSeries.pick({
    title: true,
    subtitle: true,
    specId: true,
});
export const UpdateVideoSeriesBody = CreateVideoSeriesBody.partial();
//# sourceMappingURL=video-series.js.map